export default __webpack_public_path__ + "static/media/EXTRAVERSION.0d36d809.gif";